import React, { createContext, useContext, useReducer } from 'react';

const GlobalContext = createContext();

const initialState = {
  sidebarOpen: false,
  currentPage: '/',
  theme: 'light',
  user: null,
  podcasts: [],
  newsletters: []
};

function globalReducer(state, action) {
  switch (action.type) {
    case 'TOGGLE_SIDEBAR':
      return { ...state, sidebarOpen: !state.sidebarOpen };
    case 'SET_CURRENT_PAGE':
      return { ...state, currentPage: action.payload };
    case 'SET_PODCASTS':
      return { ...state, podcasts: action.payload };
    case 'SET_NEWSLETTERS':
      return { ...state, newsletters: action.payload };
    case 'SET_USER':
      return { ...state, user: action.payload };
    case 'SET_THEME':
      return { ...state, theme: action.payload };
    default:
      return state;
  }
}

export function GlobalProvider({ children }) {
  const [state, dispatch] = useReducer(globalReducer, initialState);
  
  return (
    <GlobalContext.Provider value={{ state, dispatch }}>
      {children}
    </GlobalContext.Provider>
  );
}

export function useGlobal() {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error('useGlobal must be used within GlobalProvider');
  }
  return context;
}